import {
    BASE_URL, 
    POST,  
    GET,
    GET_ALL_CUSTOMER_LIST,
    ONEITSM_SERVICE_NAME,
    PATCH,
    FILTER_CUSTOMERS,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  

export const fetchAllCustomerList = async (requestId) => {
    const token = await getAccessToken();
    const url = `${BASE_URL}${GET_ALL_CUSTOMER_LIST}`;
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
  };

export const fetchAllMissingOneItsmCustomers = async (requestId) => {
    const token = await getAccessToken();
    const url = `${BASE_URL}${GET_ALL_CUSTOMER_LIST}/oneitsmservice-missing`;
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
  };

export const addOneITSMServiceName = async (payload,requestId) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${ONEITSM_SERVICE_NAME}${requestId}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  
  export const fetchFilteredCustomers = async() => {
    const token = await getAccessToken();
    let url = `${BASE_URL}${FILTER_CUSTOMERS}`;

    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userAuth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
      
  };